var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "messages_body" },
    _vm._l(_vm.messages, function (m, i) {
      return _c(
        "div",
        {
          class: {
            closeLine: m.type === 3,
            income: m.type === 1,
            message: true,
            system_message: m.type === 4,
          },
        },
        [
          m?.message_data?.file_path
            ? [
                !m.file_link
                  ? [
                      _c(
                        "div",
                        { staticClass: "empty_image" },
                        [
                          _c("LoadingButton", {
                            attrs: {
                              title: '<i class="icon-fa icon-fa-refresh"/>',
                              loading:
                                _vm.imageLoading[m.message_data.file_path],
                              color: _vm.$constants.SUCCESS_COLOR,
                              onClick: () => _vm.getImagePath(m, i),
                              className: "btn btn-default",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : [_c("img", { attrs: { src: m.file_link, alt: "" } })],
              ]
            : _vm._e(),
          _vm._v(" "),
          m.drug_id
            ? [
                m.message_data?.message_data?.text_on_reply
                  ? _c("p", [
                      _vm._v(
                        _vm._s(m.message_data?.message_data?.text_on_reply)
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(m.message) + " " + _vm._s(m.message_data.title) + " "
                  ),
                  _c("strong", [_vm._v(_vm._s(m.message_data.price))]),
                ]),
              ]
            : [
                _c("div", {
                  staticClass: "message_div",
                  domProps: { innerHTML: _vm._s(m.message) },
                }),
                _vm._v(" "),
                m.message_data?.url
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          attrs: { href: m.message_data.url, target: "_blank" },
                        },
                        [_vm._v("страница с который был создан\n        чат")]
                      ),
                    ])
                  : _vm._e(),
              ],
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex fs-12 justify-content-end" },
            [
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(_vm._s(_vm.printDate(m.created_at))),
              ]),
              _vm._v(" "),
              m.type === 1
                ? [
                    _c(
                      "v-popover",
                      {
                        staticClass: "ml-1 read_icon",
                        attrs: { "auto-hide": true, placement: "right" },
                      },
                      [
                        _c("i", {
                          staticClass: "icon-fa icon-fa-check-circle",
                        }),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "popover" },
                          _vm._l(m.read_by, function (r, uId) {
                            return _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.printDate(r)) +
                                    "\n              "
                                ),
                                _c("UserName", { attrs: { id: uId } }),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ],
                      2
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          [2, 3, 4].includes(m.type)
            ? _c(
                "p",
                { staticClass: "text-muted" },
                [_c("UserName", { attrs: { id: m.user_id } })],
                1
              )
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }